import React, {Component} from 'react';
import styled from "styled-components";

import {MAIN_APP} from '../MidiPlay.jsx';

import UtilIcon from '../util/UtilIcon.jsx';
import Colors from '../resource/ResourceColors.jsx';

const MediaControl = styled.div`
    float: left;
    cursor: pointer;  
    padding: 0rem 0.35rem;    
    filter: ${Colors.medium_shadow(80)};    
`;

const MediaControlGroup = styled.div`
    position: absolute;
    top: 0.2rem;  
    right: 1rem;  
    float: right;
`;

export class ModuleTransport extends Component {

    render() {
        const iconSize = "2rem";
        const iconColor = Colors.primary(95);
        return <MediaControlGroup>
            <MediaControl onClick={() => MAIN_APP.play()} title={'play media'}>
                <UtilIcon
                    icon="play-circle"
                    absSize={iconSize}
                    color={iconColor}
                    id={'play-button'}
                />
            </MediaControl>
            <MediaControl onClick={() => MAIN_APP.pause()} title={'pause media'}>
                <UtilIcon
                    icon="pause-circle"
                    absSize={iconSize}
                    color={iconColor}
                    id={'pause-button'}
                />
            </MediaControl>
            <MediaControl onClick={() => MAIN_APP.stop()} title={'stop media'}>
                <UtilIcon
                    icon="stop-circle"
                    absSize={iconSize}
                    color={iconColor}
                    id={'stop-button'}
                />
            </MediaControl>
        </MediaControlGroup>;
    }
}

export default ModuleTransport;
